var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 81,
    viewBox: "0 0 39 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1555 33.1057L27.3895 57.8729C28.8019 60.3304 31.9389 61.1776 34.3964 59.7653C36.8538 58.3529 37.7011 55.2159 36.2888 52.7584L22.0548 27.9912C20.6424 25.5338 17.5053 24.6865 15.0479 26.0989C12.5904 27.5112 11.7432 30.6483 13.1555 33.1057Z",
    fill: "#F2F4F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5651 37.79H2.94221V23.7744C2.94221 22.0443 3.62951 20.385 4.85291 19.1616C6.07631 17.9382 7.73561 17.2509 9.46576 17.2509H19.0415C22.6444 17.2509 25.5651 20.1716 25.5651 23.7744V37.79Z",
    fill: "#F2F4F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7332 80.5L22.7773 80.4434C25.5045 76.9525 24.8864 71.9138 21.3972 69.1861L19.2724 67.5256L14.2897 73.9014L22.7332 80.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1413 57.6735L25.0117 75.5228L16.3171 70.1015L27.4467 52.2521C28.9437 49.8512 32.1037 49.1184 34.5047 50.6155C36.9056 52.1126 37.6384 55.2725 36.1413 57.6735Z",
    fill: "#F2F4F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95367 51.1611V30.1619H13.1827V51.1611C13.1827 53.9858 10.8928 56.2756 8.06817 56.2756C5.24351 56.2756 2.95367 53.9858 2.95367 51.1611Z",
    fill: "#F2F4F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500479 78.8371V78.7654C0.452581 74.3366 4.00377 70.7075 8.43282 70.6596L11.1292 70.6304L11.2168 78.7216L0.500479 78.8371Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1636 51.3916L12.9536 72.3908L2.7246 72.2885L2.93459 51.2893C2.96283 48.4646 5.27557 46.1977 8.10023 46.226C10.9249 46.2542 13.1918 48.5669 13.1636 51.3916Z",
    fill: "#F2F4F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9122 7.76953V7.9963L16.8897 7.76953H16.9122Z",
    fill: "#DB666E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3618 12.5372L16.9124 12.6336V16.0013C16.9123 16.2935 16.7082 16.546 16.4226 16.6074V18.0655H10.4362V12.9212H10.4456V10.5583C10.4456 9.81875 10.7395 9.10955 11.2626 8.58679C11.7856 8.06403 12.495 7.77057 13.2345 7.771H16.8899L16.9124 7.9975L17.3618 12.5372Z",
    fill: "#DB666E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89 7.7693H16.8716L16.8819 7.68677L16.89 7.7693Z",
    fill: "#DB666E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4242 10.4562C13.4242 10.4562 14.7209 9.3518 15.9054 10.4562C15.9054 10.4562 14.8809 11.4485 13.4242 10.4562Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6734 10.8565C14.9121 10.8565 15.1056 10.663 15.1056 10.4243C15.1056 10.1857 14.9121 9.99219 14.6734 9.99219C14.4348 9.99219 14.2413 10.1857 14.2413 10.4243C14.2413 10.663 14.4348 10.8565 14.6734 10.8565Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5206 11.8003C13.5206 11.8003 14.8171 10.6956 16.0018 11.8003C16.0007 11.8003 14.9773 12.7926 13.5206 11.8003Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7691 12.2007C15.0078 12.2007 15.2012 12.0073 15.2012 11.7686C15.2012 11.5299 15.0078 11.3364 14.7691 11.3364C14.5304 11.3364 14.3369 11.5299 14.3369 11.7686C14.3369 12.0073 14.5304 12.2007 14.7691 12.2007Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8663 13.8563V25.0713H28.8544V34.2585C28.8544 35.8203 27.5883 37.0864 26.0265 37.0864C24.4647 37.0864 23.1986 35.8203 23.1986 34.2585V25.0713H20.1318V24.2814C20.1318 23.7919 20.3262 23.3223 20.6724 22.9762C21.0186 22.63 21.4881 22.4355 21.9777 22.4356H23.5082V22.3241C23.5082 22.0999 23.3265 21.9182 23.1023 21.9182H20.0444C19.7019 21.9182 19.4242 21.6405 19.4242 21.298C19.4242 20.9554 19.7019 20.6777 20.0444 20.6777H23.8511C24.0889 20.6777 24.317 20.7722 24.4851 20.9404C24.6533 21.1086 24.7477 21.3367 24.7476 21.5745V22.4351H25.8842V20.5497C25.8842 20.3256 25.7024 20.1438 25.4782 20.1438H22.4204C22.1957 20.1485 21.9861 20.0314 21.8724 19.8376C21.7588 19.6438 21.7588 19.4037 21.8724 19.2099C21.9861 19.0161 22.1957 18.8989 22.4204 18.9036H26.2295C26.4673 18.9036 26.6954 18.998 26.8636 19.1661C27.0318 19.3343 27.1262 19.5623 27.1262 19.8002V22.4356H27.4364V18.9989C27.4364 18.7747 27.2546 18.593 27.0305 18.593H23.9726C23.63 18.593 23.3523 18.3153 23.3523 17.9727C23.3523 17.6302 23.63 17.3525 23.9726 17.3525H27.5906V13.8563C27.5859 13.6254 27.7063 13.41 27.9055 13.2932C28.1046 13.1764 28.3514 13.1764 28.5506 13.2932C28.7498 13.41 28.8702 13.6254 28.8654 13.8563H28.8663Z",
    fill: "#DB666E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1239 20.6914C21.1239 20.6914 21.0176 21.372 19.4662 21.1669",
    stroke: "white",
    strokeWidth: 0.0541217,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.829 14.9138C28.829 14.9138 28.1482 14.8077 28.3536 13.2563",
    stroke: "white",
    strokeWidth: 0.0541217,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0513 17.3669C25.0513 17.3669 24.9449 18.0478 23.3938 17.8424",
    stroke: "white",
    strokeWidth: 0.0541217,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5014 18.9175C23.5014 18.9175 23.3953 19.5981 21.8439 19.3927",
    stroke: "white",
    strokeWidth: 0.0541217,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5942 1.64765C31.1743 2.77311 32.2101 4.62028 32.2101 6.69693C32.2101 10.1066 29.4229 12.8939 26.0132 12.8939C22.6035 12.8939 19.8163 10.1066 19.8163 6.69693C19.8163 4.61758 20.8541 2.76878 22.4377 1.64332C23.4814 0.899128 24.7314 0.499419 26.0132 0.500001C27.2976 0.499423 28.5499 0.900721 29.5947 1.64765",
    fill: "#F2F4F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3575 12.2563C24.3203 10.1764 25.9539 5.37125 22.8741 1.39331",
    stroke: "white",
    strokeWidth: 0.0535804,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3145 11.881C28.3709 9.76785 27.0143 5.42107 29.5816 1.67261",
    stroke: "white",
    strokeWidth: 0.0541217,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 6.83576C30.874 6.12514 24.6167 3.10677 19.8973 7.4817",
    stroke: "white",
    strokeWidth: 0.0530392,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5433 13.449C11.0913 13.4489 11.5355 13.0047 11.5357 12.4567V12.0884C11.2617 12.0884 11.0395 11.8664 11.0394 11.5924V11.4002C11.0394 11.2686 11.0916 11.1424 11.1847 11.0493C11.2778 10.9562 11.404 10.904 11.5357 10.904H11.6637V10.5311C11.6637 9.74698 12.2992 9.11132 13.0833 9.11117H16.3482C16.5831 9.11117 16.8085 9.01783 16.9746 8.85168C17.1408 8.68553 17.2341 8.46018 17.2341 8.2252V8.01359C17.2341 7.74433 17.1271 7.48611 16.9367 7.29574C16.7463 7.10537 16.4881 6.99846 16.2188 6.99854H13.4029C12.5596 6.99832 11.7509 7.33314 11.1546 7.92931C10.5582 8.52548 10.2232 9.33415 10.2232 10.1774V12.631C10.2232 12.9327 10.2998 13.2639 10.5412 13.445C10.5425 13.4459 10.5433 13.4474 10.5433 13.449Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.c753643058f3410c5b269a2ca9f3b334.svg";
export { ForwardRef as ReactComponent };